"use strict";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
let imagesLoaded = require('imagesloaded');
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
gsap.registerPlugin(ScrollTrigger);
document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');
    // menu
    const menuBtn = document.getElementById('menu-burger');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('menu-overlay');
    const menuItems = gsap.utils.toArray('.menuItems a');
    const sMenuBtn = gsap.utils.toArray('.menuItems .has-submenu-arrow');
    const sMenuBtn2 = gsap.utils.toArray('.menuItems .has-submenu');
    let nav = document.querySelector(".navbar");
    let scrollTop = document.getElementById("scroll-top");
    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 1199;
    let isMobileG = false;
    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {
        let {isDesktop, isMobile} = context.conditions;
        // hide overlay
        gsap.set(overlay, {
            marginTop: isMobile ? "-100vh" : 0
        })

        isMobileG = !!isMobile;
        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.2
            })
            .to(b2, {
                y: '+=5',
                duration: 0.2
            }, "-=0.2")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.3
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.3
            }, "-=0.3")
            .to(overlay, {
                marginTop: 0,
                duration: 0.5
            }, "-=0.5")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.05,
                duration: 0.5
            }, "-=0.2")
        navTl.pause();
    })

    // toggle menu

    menuBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!menuOpen) {
            navTl.play();
            menuOpen = true;
        } else {
            navTl.reverse();
            menuOpen = false;
        }
    })

    if(isMobileG){
        [].forEach.call(sMenuBtn, function (btn) {
            btn.parentNode.parentNode.querySelector('.back-sub').addEventListener('click', (evt) => {
                console.log(btn)
                btn.parentNode.parentNode.classList.remove('open')
            })
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (btn.parentNode.classList.contains('open')) {
                    btn.parentNode.classList.remove('open')
                } else {
                    btn.parentNode.classList.add('open')
                }
            })
        })
    }else{
        [].forEach.call(sMenuBtn2, function (btn) {
            btn.addEventListener('mouseenter', (evt) => {
                nav.classList.add('sub-active')
            })
            btn.addEventListener('mouseleave', (evt) => {
                nav.classList.remove('sub-active')
            })
        });
    }


    // navbar shrink
    window.addEventListener("scroll", function () {

        if (window.scrollY > 100) {
            scrollTop.classList.add('show')
            nav.classList.add("shrink");
        } else {
            scrollTop.classList.remove('show')
            nav.classList.remove("shrink");
        }
    });


    imagesLoaded(document.querySelector("main"), function (instance) {
        const stl = gsap.timeline();
        stl.to('.loader', {opacity: 0, duration: 0.3}, '-=0');
        stl.to('.navbar', {opacity: 1, duration: 0.6}, '-=0');
        stl.to('main', {opacity: 1, duration: 0.6}, '-=0.3');
        stl.to('footer', {opacity: 1, duration: 0.6}, '-=0');

        if(document.querySelector(".hero")) {

        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".hero",
                start: "top top",
                end: "bottom top",
                scrub: true
            }
        });
        gsap.utils.toArray(".parallax").forEach(layer => {
            const depth = layer.dataset.depth;
            const movement = -(layer.offsetHeight * depth)
            tl.to(layer, {y: movement, ease: "none"}, 0)
        });

        // swiper
        const swiper = new Swiper('.stimmen-swiper', {
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 16,
        });


    })

});

